import { GraphApproval, GraphApprovalStatus } from "@custom-types/graphs"
import { yupResolver } from "@hookform/resolvers/yup"
import { Button, Grid, TextField } from "@mui/material"
import { getErrorMessage } from "@utils/form"
import { useEffect } from "react"
import { Controller, FormProvider, useForm } from "react-hook-form"
import * as yup from "yup"

const validationSchema = yup.object({
  comment: yup.string().max(255),
})

export type ApproveDenyGraphRunFormValues = yup.InferType<typeof validationSchema>

type ApproveDenyGraphRunFormProps = {
  approval: GraphApproval
  onSubmit: (values: ApproveDenyGraphRunFormValues, status: GraphApprovalStatus) => void
}

const ApproveDenyGraphRunForm = (props: ApproveDenyGraphRunFormProps) => {
  const form = useForm({
    defaultValues: { comment: props.approval.comments },
    resolver: yupResolver(validationSchema),
  })

  useEffect(() => {
    form.reset({ comment: props.approval.comments })
  }, [props.approval, form])

  const handleSubmit = (status: GraphApprovalStatus) => {
    form.handleSubmit((values) => props.onSubmit(values, status))()
  }

  const errors = form.formState.errors

  return (
    <FormProvider {...form}>
      <form autoComplete="off">
        <Grid container direction="column" gap={2}>
          <Grid item>
            <Controller
              control={form.control}
              name="comment"
              render={({ field }) => (
                <TextField
                  error={!!errors[field.name]}
                  helperText={getErrorMessage(errors, field.name)}
                  label="Comment"
                  fullWidth
                  {...field}
                />
              )}
            />
          </Grid>

          <Grid container justifyContent="center" gap={2}>
            <Grid item>
              <Button
                color="success"
                variant="contained"
                onClick={() => handleSubmit(GraphApprovalStatus.Approved)}
              >
                Approve
              </Button>
            </Grid>
            <Grid item>
              <Button
                color="error"
                variant="contained"
                onClick={() => handleSubmit(GraphApprovalStatus.Denied)}
              >
                Deny
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </form>
    </FormProvider>
  )
}

export default ApproveDenyGraphRunForm
